var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50012 1.9001C5.412 1.9001 2.73345 4.75244 2.73345 8.5001L2.73343 12.2501C2.73343 12.4705 2.65254 12.6833 2.5061 12.848L1.9001 13.5298V15.1001H15.1001V13.5298L14.4941 12.848C14.3477 12.6833 14.2668 12.4705 14.2668 12.2501L14.2668 8.5001C14.2668 4.75243 11.5882 1.9001 8.50012 1.9001ZM0.93345 8.5001C0.93345 3.96349 4.22444 0.100098 8.50012 0.100098C12.7758 0.100098 16.0668 3.96349 16.0668 8.5001L16.0668 11.9079L16.6728 12.5897C16.8192 12.7544 16.9001 12.9672 16.9001 13.1876V16.0001C16.9001 16.4972 16.4972 16.9001 16.0001 16.9001H1.0001C0.503041 16.9001 0.100098 16.4972 0.100098 16.0001V13.1876C0.100098 12.9672 0.180988 12.7544 0.327429 12.5897L0.933433 11.9079L0.93345 8.5001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 16.0001C11.0001 17.3808 9.88081 18.5001 8.5001 18.5001C7.11939 18.5001 6.0001 17.3808 6.0001 16.0001H11.0001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.374610665a8abfba3f538311207e0f2a.svg";
export { ForwardRef as ReactComponent };